export default "__VITE_ASSET__D1a3bIv___"